/**
 * Permission constants using bitmask pattern
 * Auto-generated from C# PermissionType.cs
 * Generated on: 2025-01-XX
 * Total permissions: 149 (bit indexes 0-148)
 * 
 * All permissions use BigInt to handle large bitmask values
 */

/**
 * Permission constants object
 * Maps C# PermissionType fields to TypeScript BigInt values
 */
export const PERMISSIONS = {
  // Bit index: 0
  ADDING_CONTENT_IN_NEWS_SECTION: 1n << 0n,
  
  // Bit index: 1
  EDITING_CONTENT_IN_NEWS_SECTION: 1n << 1n,
  
  // Bit index: 2
  DELETE_CONTENT_IN_NEWS_SECTION: 1n << 2n,
  
  // Bit index: 3
  RESTORE_CONTENT_IN_NEWS_SECTION: 1n << 3n,
  
  // Bit index: 4
  REVIEW_CONTENT_IN_NEWS_SECTION: 1n << 4n,
  
  // Bit index: 5
  VIEW_EMPLOYEE_NEWS: 1n << 5n,
  
  // Bit index: 6
  VIEW_ADVISOR_NEWS: 1n << 6n,
  
  // Bit index: 7
  VIEW_NEWS_FOR_SPECIFIC_USERS: 1n << 7n,
  
  // Bit index: 8
  ADDING_CONTENT_IN_HEADS_ADMINISTRATIVE_SECTION: 1n << 8n,
  
  // Bit index: 9
  DELETE_CONTENT_IN_HEADS_ADMINISTRATIVE_SECTION: 1n << 9n,
  
  // Bit index: 10
  RESTORE_CONTENT_IN_HEADS_ADMINISTRATIVE_SECTION: 1n << 10n,
  
  // Bit index: 11
  EDITING_CONTENT_IN_HEADS_ADMINISTRATIVE_SECTION: 1n << 11n,
  
  // Bit index: 12
  REVIEW_CONTENT_IN_HEADS_ADMINISTRATIVE_SECTION: 1n << 12n,
  
  // Bit index: 13
  ADD_SERVICE_IN_SERVICES_SECTION: 1n << 13n,
  
  // Bit index: 14
  DELETE_SERVICE_IN_SERVICES_SECTION: 1n << 14n,
  
  // Bit index: 15
  REVIEW_SERVICE_IN_SERVICES_SECTION: 1n << 15n,
  
  // Bit index: 16
  EDIT_SERVICE_IN_SERVICES_SECTION: 1n << 16n,
  
  // Bit index: 17
  SHOW_SERVICES_SECTION: 1n << 17n,
  
  // Bit index: 18
  USER_UPDATE_REQUESTS_SECTION_REVIEW: 1n << 18n,
  
  // Bit index: 19
  ADDING_CONTENT_IN_ABOUT_SECTION: 1n << 19n,
  
  // Bit index: 20
  EDITING_CONTENT_IN_ABOUT_SECTION: 1n << 20n,
  
  // Bit index: 21
  DELETE_CONTENT_IN_ABOUT_SECTION: 1n << 21n,
  
  // Bit index: 22
  RESTORE_CONTENT_IN_ABOUT_SECTION: 1n << 22n,
  
  // Bit index: 23
  REVIEW_CONTENT_IN_ABOUT_SECTION: 1n << 23n,
  
  // Bit index: 24
  CHANGE_TO_CURRENT_INFO: 1n << 24n,
  
  // Bit index: 25
  ADD_SOCIAL_MEDIA_LINK_IN_CONTACT_US_SECTION: 1n << 25n,
  
  // Bit index: 26
  EDIT_SOCIAL_MEDIA_LINK_IN_CONTACT_US_SECTION: 1n << 26n,
  
  // Bit index: 27
  DELETE_SOCIAL_MEDIA_LINK_IN_CONTACT_US_SECTION: 1n << 27n,
  
  // Bit index: 28
  ADD_BRANCH_IN_CONTACT_US_SECTION: 1n << 28n,
  
  // Bit index: 29
  EDIT_BRANCH_IN_CONTACT_US_SECTION: 1n << 29n,
  
  // Bit index: 30
  DELETE_BRANCH_IN_CONTACT_US_SECTION: 1n << 30n,
  
  // Bit index: 31
  REQUEST_REST_SERVICE: 1n << 31n,
  
  // Bit index: 32
  DAYOFF_REQUESTS_SECTION_REVIEW: 1n << 32n,
  
  // Bit index: 33
  SHOW_DAYOFF_REQUESTS_SECTION: 1n << 33n,
  
  // Bit index: 34
  REQUEST_TRANSFER_SERVICE: 1n << 34n,
  
  // Bit index: 35
  TRANSFER_REQUESTS_SECTION_REVIEW: 1n << 35n,
  
  // Bit index: 36
  SHOW_TRANSFER_REQUESTS_SECTION: 1n << 36n,
  
  // Bit index: 37
  REQUEST_TRANSFER_APPEAL_SERVICE: 1n << 37n,
  
  // Bit index: 38
  TRANSFER_APPEAL_REQUESTS_SECTION_REVIEW: 1n << 38n,
  
  // Bit index: 39
  SHOW_TRANSFER_APPEAL_REQUESTS_SECTION: 1n << 39n,
  
  // Bit index: 40
  ADD_SECURITY_DIRECTORATE_MANAGEMENT: 1n << 40n,
  
  // Bit index: 41
  EDIT_SECURITY_DIRECTORATE_MANAGEMENT: 1n << 41n,
  
  // Bit index: 42
  DELETE_SECURITY_DIRECTORATE_MANAGEMENT: 1n << 42n,
  
  // Bit index: 43
  SHOW_SECURITY_DIRECTORATE_MANAGEMENT_SECTION: 1n << 43n,
  
  // Bit index: 44
  REQUEST_WEAPON_LICENSE_SERVICE: 1n << 44n,
  
  // Bit index: 45
  WEAPON_LICENSE_REQUESTS_SECTION_REVIEW: 1n << 45n,
  
  // Bit index: 46
  SHOW_WEAPON_LICENSE_REQUESTS_SECTION: 1n << 46n,
  
  // Bit index: 47
  REQUEST_EXTERNAL_CORRESPONDENCE_SERVICE: 1n << 47n,
  
  // Bit index: 48
  EXTERNAL_CORRESPONDENCE_REQUESTS_SECTION_REVIEW: 1n << 48n,
  
  // Bit index: 49
  SHOW_EXTERNAL_CORRESPONDENCE_REQUESTS_SECTION: 1n << 49n,
  
  // Bit index: 50
  REQUEST_BANK_SALARY_CARD_SERVICE: 1n << 50n,
  
  // Bit index: 51
  BANK_SALARY_CARD_REQUESTS_SECTION_REVIEW: 1n << 51n,
  
  // Bit index: 52
  SHOW_BANK_SALARY_CARD_REQUESTS_SECTION: 1n << 52n,
  
  // Bit index: 53
  REQUEST_CAREER_PROGRESSION_SERVICE: 1n << 53n,
  
  // Bit index: 54
  CAREER_PROGRESSION_REQUESTS_SECTION_REVIEW: 1n << 54n,
  
  // Bit index: 55
  SHOW_CAREER_PROGRESSION_REQUESTS_SECTION: 1n << 55n,
  
  // Bit index: 56
  REQUEST_INCOME_CERTIFICATE_SERVICE: 1n << 56n,
  
  // Bit index: 57
  INCOME_CERTIFICATE_REQUESTS_SECTION_REVIEW: 1n << 57n,
  
  // Bit index: 58
  SHOW_INCOME_CERTIFICATE_REQUESTS_SECTION: 1n << 58n,
  
  // Bit index: 59
  ADD_GRIEVANCE_TYPE_MANAGEMENT: 1n << 59n,
  
  // Bit index: 60
  EDIT_GRIEVANCE_TYPE_MANAGEMENT: 1n << 60n,
  
  // Bit index: 61
  DELETE_GRIEVANCE_TYPE_MANAGEMENT: 1n << 61n,
  
  // Bit index: 62
  SHOW_GRIEVANCE_TYPE_MANAGEMENT_SECTION: 1n << 62n,
  
  // Bit index: 63
  REQUEST_SALARY_BREAKDOWN_SERVICE: 1n << 63n,
  
  // Bit index: 64
  SALARY_BREAKDOWN_REQUESTS_SECTION_REVIEW: 1n << 64n,
  
  // Bit index: 65
  SHOW_SALARY_BREAKDOWN_REQUESTS_SECTION: 1n << 65n,
  
  // Bit index: 66
  REQUEST_GRIEVANCE_SERVICE: 1n << 66n,
  
  // Bit index: 67
  GRIEVANCE_REQUESTS_SECTION_REVIEW: 1n << 67n,
  
  // Bit index: 68
  SHOW_GRIEVANCE_REQUESTS_SECTION: 1n << 68n,
  
  // Bit index: 69
  REQUEST_DATA_AMENDMENT_SERVICE: 1n << 69n,
  
  // Bit index: 70
  SHOW_USER_UPDATE_REQUESTS_SECTION: 1n << 70n,
  
  // Bit index: 71
  REQUEST_LEAVE_SERVICE: 1n << 71n,
  
  // Bit index: 72
  VACATION_REQUESTS_SECTION_REVIEW: 1n << 72n,
  
  // Bit index: 73
  SHOW_VACATION_REQUESTS_SECTION: 1n << 73n,
  
  // Bit index: 74
  EDIT_PROSECUTION_MANAGEMENT: 1n << 74n,
  
  // Bit index: 75
  ADD_PROSECUTION_MANAGEMENT: 1n << 75n,
  
  // Bit index: 76
  SHOW_PROSECUTION_SERVICES_SECTION: 1n << 76n,
  
  // Bit index: 77
  REQUEST_PUBLIC_PROSECUTION_TRANSFER_SERVICE: 1n << 77n,
  
  // Bit index: 78
  PROSECUTION_TRANSFER_SERVICES_SECTION_REVIEW: 1n << 78n,
  
  // Bit index: 79
  SHOW_PROSECUTION_TRANSFER_SERVICES_SECTION: 1n << 79n,
  
  // Bit index: 80
  REQUEST_PUBLIC_PROSECUTION_TRANSPORTATION_BOOK_SERVICE: 1n << 80n,
  
  // Bit index: 81
  PROSECUTION_TRANSPORTATION_BOOK_SERVICES_SECTION_REVIEW: 1n << 81n,
  
  // Bit index: 82
  SHOW_PROSECUTION_TRANSPORTATION_BOOK_SERVICES_SECTION: 1n << 82n,
  
  // Bit index: 83
  REQUEST_COMPLAINTS_SERVICE: 1n << 83n,
  
  // Bit index: 84
  SHOW_COMPLAINT_REQUESTS_SECTION: 1n << 84n,
  
  // Bit index: 85
  COMPLAINT_REQUESTS_SECTION_REVIEW: 1n << 85n,
  
  // Bit index: 86
  REQUEST_CERTIFICATE_SERVICE: 1n << 86n,
  
  // Bit index: 87
  SHOW_CERTIFICATION_REQUESTS_SECTION: 1n << 87n,
  
  // Bit index: 88
  CERTIFICATION_REQUESTS_SECTION_REVIEW: 1n << 88n,
  
  // Bit index: 89
  ADDING_CONTENT_IN_TRAINING_SECTION: 1n << 89n,
  
  // Bit index: 90
  EDITING_CONTENT_IN_TRAINING_SECTION: 1n << 90n,
  
  // Bit index: 91
  DELETE_CONTENT_IN_TRAINING_SECTION: 1n << 91n,
  
  // Bit index: 92
  REVIEW_CONTENT_IN_TRAINING_SECTION: 1n << 92n,
  
  // Bit index: 93
  REGISTER_FOR_TRAINING_SECTION: 1n << 93n,
  
  // Bit index: 94
  REVIEW_REGISTRATION_IN_TRAINING_SECTION: 1n << 94n,
  
  // Bit index: 95
  SHOW_TRAINING_SECTION_MANAGEMENT: 1n << 95n,
  
  // Bit index: 96
  ADDING_CONTENT_IN_TRAINING_SECTION_MANAGEMENT: 1n << 96n,
  
  // Bit index: 97
  EDITING_CONTENT_IN_TRAINING_SECTION_MANAGEMENT: 1n << 97n,
  
  // Bit index: 98
  DELETE_CONTENT_IN_TRAINING_SECTION_MANAGEMENT: 1n << 98n,
  
  // Bit index: 99
  REVIEW_CONTENT_IN_TRAINING_SECTION_MANAGEMENT: 1n << 99n,
  
  // Bit index: 100
  ADDING_CONTENT_IN_TRAINERS_SECTION: 1n << 100n,
  
  // Bit index: 101
  EDITING_CONTENT_IN_TRAINERS_SECTION: 1n << 101n,
  
  // Bit index: 102
  DELETE_CONTENT_IN_TRAINERS_SECTION: 1n << 102n,
  
  // Bit index: 103
  SHOW_TRAINERS_SECTION: 1n << 103n,
  
  // Bit index: 104
  REVIEW_EMAIL_IN_EMAIL_SUBSCRIPTION_SECTION: 1n << 104n,
  
  // Bit index: 105
  SHOW_EMAIL_SUBSCRIPTION_SECTION: 1n << 105n,
  
  // Bit index: 106
  SHOW_USER_MANAGEMENT_SECTION: 1n << 106n,
  
  // Bit index: 107
  EDIT_USER_MANAGEMENT_SECTION: 1n << 107n,
  
  // Bit index: 108
  ADD_USER_MANAGEMENT_SECTION: 1n << 108n,
  
  // Bit index: 109
  ADD_GOVERNORATE_MANAGEMENT: 1n << 109n,
  
  // Bit index: 110
  EDIT_GOVERNORATE_MANAGEMENT: 1n << 110n,
  
  // Bit index: 111
  SHOW_GOVERNORATE_MANAGEMENT_SECTION: 1n << 111n,
  
  // Bit index: 112
  ADD_MINISTRY_MANAGEMENT: 1n << 112n,
  
  // Bit index: 113
  EDIT_MINISTRY_MANAGEMENT: 1n << 113n,
  
  // Bit index: 114
  SHOW_MINISTRY_MANAGEMENT_SECTION: 1n << 114n,
  
  // Bit index: 115
  ADD_POLICE_DEPARTMENT_MANAGEMENT: 1n << 115n,
  
  // Bit index: 116
  EDIT_POLICE_DEPARTMENT_MANAGEMENT: 1n << 116n,
  
  // Bit index: 117
  SHOW_POLICE_DEPARTMENT_MANAGEMENT_SECTION: 1n << 117n,
  
  // Bit index: 118
  ADD_POSITION_MANAGEMENT: 1n << 118n,
  
  // Bit index: 119
  EDIT_POSITION_MANAGEMENT: 1n << 119n,
  
  // Bit index: 120
  SHOW_POSITION_MANAGEMENT_SECTION: 1n << 120n,
  
  // Bit index: 121
  EDIT_LEAVE_TYPE_MANAGEMENT: 1n << 121n,
  
  // Bit index: 122
  SHOW_LEAVE_TYPE_MANAGEMENT_SECTION: 1n << 122n,
  
  // Bit index: 123
  ADDING_CONTENT_IN_JOB_ANNOUNCEMENT_SECTION: 1n << 123n,
  
  // Bit index: 124
  EDITING_CONTENT_IN_JOB_ANNOUNCEMENT_SECTION: 1n << 124n,
  
  // Bit index: 125
  DELETE_CONTENT_IN_JOB_ANNOUNCEMENT_SECTION: 1n << 125n,
  
  // Bit index: 126
  SHOW_JOB_ANNOUNCEMENT_SECTION: 1n << 126n,
  
  // Bit index: 127
  ADDING_CONTENT_IN_NEWS_IMAGE_SECTION: 1n << 127n,
  
  // Bit index: 128
  DELETE_CONTENT_IN_NEWS_IMAGE_SECTION: 1n << 128n,
  
  // Bit index: 129
  ADDING_CONTENT_IN_SECRETARY_GENERAL_SECTION: 1n << 129n,
  
  // Bit index: 130
  EDITING_CONTENT_IN_SECRETARY_GENERAL_SECTION: 1n << 130n,
  
  // Bit index: 131
  DELETE_CONTENT_IN_SECRETARY_GENERAL_SECTION: 1n << 131n,
  
  // Bit index: 132
  REVIEW_CONTENT_IN_SECRETARY_GENERAL_SECTION: 1n << 132n,
  
  // Bit index: 133
  SHOW_SECRETARY_GENERAL_SECTION: 1n << 133n,
  
  // Bit index: 134
  ADMIN_SYSTEM: 1n << 134n,
  
  // Bit index: 135
  PERMISSIONS_SYSTEM: 1n << 135n,
  
  // Bit index: 136
  NO_SUBJECT_REVIEW: 1n << 136n,
  
  // Bit index: 137
  VIEW_REPORT: 1n << 137n,
  
  // Bit index: 138
  HIRING_SECTION_MANAGMENT: 1n << 138n,
  
  // Bit index: 139
  HIRING_SECTION_REVIEW: 1n << 139n,
  
  // Bit index: 140
  VIEW_HIRING_STATICS_SECTION: 1n << 140n,
  
  // Bit index: 141
  SCHEDULING_DELIVERING_DOCUMENTS_SECTION_MANAGMENT: 1n << 141n,
  
  // Bit index: 142
  SCHEDULE_INTERVIEWS_SECTION_MANAGMENT: 1n << 142n,
  
  // Bit index: 143
  ABSENTEES_SECTION_MANAGMENT: 1n << 143n,
  
  // Bit index: 144
  EXCEPTION_SECTION_MANAGEMENT: 1n << 144n,
  
  // Bit index: 145
  APPLICANT_REVIEW_SECTION_MANAGEMENT: 1n << 145n,
  
  // Bit index: 146
  ROLE_MANAGEMENT_SECTION_MANAGMENT: 1n << 146n,
  
  // Bit index: 147
  PERMISSION_MANAGEMENT_SECTION: 1n << 147n,
  
  // Bit index: 148
  USER_AUTH_MANAGEMENT_SECTION: 1n << 148n,
  
  // Bit index: 149
  REQUEST_HEALTH_CARE_CARD_SERVICE: 1n << 149n,
  
  // Bit index: 150
  HEALTH_CARE_CARD_REQUESTS_SECTION_REVIEW: 1n << 150n,
  
  // Bit index: 151
  SHOW_HEALTH_CARE_CARD_REQUESTS_SECTION: 1n << 151n,
  
  // Bit index: 231
  DELETE_OWN_ACCOUNT: 1n << 231n,
} as const;

/**
 * Mapping from bit index to permission name
 */
const BIT_INDEX_TO_NAME: Record<number, string> = {
  0: 'AddingContentInNewsSection',
  1: 'EditingContentInNewsSection',
  2: 'DeleteContentInNewsSection',
  3: 'RestoreContentInNewsSection',
  4: 'ReviewContentInNewsSection',
  5: 'ViewEmployeeNews',
  6: 'ViewAdvisorNews',
  7: 'ViewNewsForSpecificUsers',
  8: 'AddingContentInHeadsAdministrativeSection',
  9: 'DeleteContentInHeadsAdministrativeSection',
  10: 'RestoreContentInHeadsAdministrativeSection',
  11: 'EditingContentInHeadsAdministrativeSection',
  12: 'ReviewContentInHeadsAdministrativeSection',
  13: 'AddServiceInServicesSection',
  14: 'DeleteServiceInServicesSection',
  15: 'ReviewServiceInServicesSection',
  16: 'EditServiceInServicesSection',
  17: 'showServicesSection',
  18: 'userUpdateRequestsSectionReview',
  19: 'AddingContentInAboutSection',
  20: 'EditingContentInAboutSection',
  21: 'DeleteContentInAboutSection',
  22: 'RestoreContentInAboutSection',
  23: 'ReviewContentInAboutSection',
  24: 'ChangeToCurrentInfo',
  25: 'AddSocialMediaLinkInContactUsSection',
  26: 'EditSocialMediaLinkInContactUsSection',
  27: 'DeleteSocialMediaLinkInContactUsSection',
  28: 'AddBranchInContactUsSection',
  29: 'EditBranchInContactUsSection',
  30: 'DeleteBranchInContactUsSection',
  31: 'RequestRestService',
  32: 'dayoffRequestsSectionReview',
  33: 'showDayoffRequestsSection',
  34: 'RequestTransferService',
  35: 'transferRequestsSectionReview',
  36: 'showTransferRequestsSection',
  37: 'RequestTransferAppealService',
  38: 'transferAppealRequestsSectionReview',
  39: 'showTransferAppealRequestsSection',
  40: 'addSecurityDirectorateManagement',
  41: 'editSecurityDirectorateManagement',
  42: 'deleteSecurityDirectorateManagement',
  43: 'showSecurityDirectorateManagementSection',
  44: 'RequestWeaponLicenseService',
  45: 'weaponLicenseRequestsSectionReview',
  46: 'showWeaponLicenseRequestsSection',
  47: 'RequestExternalCorrespondenceService',
  48: 'externalCorrespondenceRequestsSectionReview',
  49: 'showExternalCorrespondenceRequestsSection',
  50: 'RequestBankSalaryCardService',
  51: 'bankSalaryCardRequestsSectionReview',
  52: 'showBankSalaryCardRequestsSection',
  53: 'RequestCareerProgressionService',
  54: 'careerProgressionRequestsSectionReview',
  55: 'showCareerProgressionRequestsSection',
  56: 'RequestIncomeCertificateService',
  57: 'incomeCertificateRequestsSectionReview',
  58: 'showIncomeCertificateRequestsSection',
  59: 'addGrievanceTypeManagement',
  60: 'editGrievanceTypeManagement',
  61: 'deleteGrievanceTypeManagement',
  62: 'showGrievanceTypeManagementSection',
  63: 'RequestSalaryBreakdownService',
  64: 'salaryBreakdownRequestsSectionReview',
  65: 'showSalaryBreakdownRequestsSection',
  66: 'RequestGrievanceService',
  67: 'grievanceRequestsSectionReview',
  68: 'showGrievanceRequestsSection',
  69: 'RequestDataAmendmentService',
  70: 'showUserUpdateRequestsSection',
  71: 'RequestLeaveService',
  72: 'vacationRequestsSectionReview',
  73: 'showVacationRequestsSection',
  74: 'editProsecutionManagement',
  75: 'addProsecutionManagement',
  76: 'showProsecutionServicesSection',
  77: 'RequestPublicProsecutionTransferService',
  78: 'prosecutionTransferServicesSectionReview',
  79: 'showProsecutionTransferServicesSection',
  80: 'RequestPublicProsecutionTransportationBookService',
  81: 'prosecutionTransportationBookServicesSectionReview',
  82: 'showProsecutionTransportationBookServicesSection',
  83: 'RequestComplaintsService',
  84: 'showComplaintRequestsSection',
  85: 'complaintRequestsSectionReview',
  86: 'RequestCertificateService',
  87: 'showCertificationRequestsSection',
  88: 'certificationRequestsSectionReview',
  89: 'AddingContentInTrainingSection',
  90: 'EditingContentInTrainingSection',
  91: 'DeleteContentInTrainingSection',
  92: 'ReviewContentInTrainingSection',
  93: 'RegisterForTrainingSection',
  94: 'ReviewRegistrationInTrainingSection',
  95: 'ShowTrainingSectionManagement',
  96: 'AddingContentInTrainingSectionManagement',
  97: 'EditingContentInTrainingSectionManagement',
  98: 'DeleteContentInTrainingSectionManagement',
  99: 'ReviewContentInTrainingSectionManagement',
  100: 'AddingContentInTrainersSection',
  101: 'EditingContentInTrainersSection',
  102: 'DeleteContentInTrainersSection',
  103: 'showTrainersSection',
  104: 'ReviewEmailInEmailSubscriptionSection',
  105: 'showEmailSubscriptionSection',
  106: 'showUserManagementSection',
  107: 'editUserManagementSection',
  108: 'addUserManagementSection',
  109: 'addGovernorateManagement',
  110: 'editGovernorateManagement',
  111: 'showGovernorateManagementSection',
  112: 'addMinistryManagement',
  113: 'editMinistryManagement',
  114: 'showMinistryManagementSection',
  115: 'addPoliceDepartmentManagement',
  116: 'editPoliceDepartmentManagement',
  117: 'showPoliceDepartmentManagementSection',
  118: 'addPositionManagement',
  119: 'editPositionManagement',
  120: 'showPositionManagementSection',
  121: 'editLeaveTypeManagement',
  122: 'showLeaveTypeManagementSection',
  123: 'AddingContentInJobAnnouncementSection',
  124: 'EditingContentInJobAnnouncementSection',
  125: 'DeleteContentInJobAnnouncementSection',
  126: 'showJobAnnouncementSection',
  127: 'AddingContentInNewsImageSection',
  128: 'DeleteContentInNewsImageSection',
  129: 'AddingContentInSecretaryGeneralSection',
  130: 'EditingContentInSecretaryGeneralSection',
  131: 'DeleteContentInSecretaryGeneralSection',
  132: 'ReviewContentInSecretaryGeneralSection',
  133: 'showSecretaryGeneralSection',
  134: 'AdminSystem',
  135: 'PermissionsSystem',
  136: 'NoSubjectReview',
  137: 'ViewReport',
  138: 'hiringSectionManagment',
  139: 'hiringSectionReview',
  140: 'viewHiringStaticsSection',
  141: 'schedulingDeliveringDocumentsSectionManagment',
  142: 'scheduleInterviewsSectionManagment',
  143: 'absenteesSectionManagment',
  144: 'exceptionSectionManagement',
  145: 'applicantReviewSectionManagement',
  146: 'roleManagementSectionManagment',
  147: 'permissionManagementSection',
  148: 'userAuthManagementSection',
  149: 'RequestHealthCareCardService',
  150: 'healthCareCardRequestsSectionReview',
  151: 'showHealthCareCardRequestsSection',
  231: 'DeleteOwnAccount',
};

/**
 * Mapping from permission name to bit index
 */
const NAME_TO_BIT_INDEX: Record<string, number> = Object.fromEntries(
  Object.entries(BIT_INDEX_TO_NAME).map(([index, name]) => [name, Number(index)])
);

/**
 * Mapping from permission name to BigInt value
 */
const NAME_TO_PERMISSION: Record<string, bigint> = {
  AddingContentInNewsSection: PERMISSIONS.ADDING_CONTENT_IN_NEWS_SECTION,
  EditingContentInNewsSection: PERMISSIONS.EDITING_CONTENT_IN_NEWS_SECTION,
  DeleteContentInNewsSection: PERMISSIONS.DELETE_CONTENT_IN_NEWS_SECTION,
  RestoreContentInNewsSection: PERMISSIONS.RESTORE_CONTENT_IN_NEWS_SECTION,
  ReviewContentInNewsSection: PERMISSIONS.REVIEW_CONTENT_IN_NEWS_SECTION,
  ViewEmployeeNews: PERMISSIONS.VIEW_EMPLOYEE_NEWS,
  ViewAdvisorNews: PERMISSIONS.VIEW_ADVISOR_NEWS,
  ViewNewsForSpecificUsers: PERMISSIONS.VIEW_NEWS_FOR_SPECIFIC_USERS,
  AddingContentInHeadsAdministrativeSection: PERMISSIONS.ADDING_CONTENT_IN_HEADS_ADMINISTRATIVE_SECTION,
  DeleteContentInHeadsAdministrativeSection: PERMISSIONS.DELETE_CONTENT_IN_HEADS_ADMINISTRATIVE_SECTION,
  RestoreContentInHeadsAdministrativeSection: PERMISSIONS.RESTORE_CONTENT_IN_HEADS_ADMINISTRATIVE_SECTION,
  EditingContentInHeadsAdministrativeSection: PERMISSIONS.EDITING_CONTENT_IN_HEADS_ADMINISTRATIVE_SECTION,
  ReviewContentInHeadsAdministrativeSection: PERMISSIONS.REVIEW_CONTENT_IN_HEADS_ADMINISTRATIVE_SECTION,
  AddServiceInServicesSection: PERMISSIONS.ADD_SERVICE_IN_SERVICES_SECTION,
  DeleteServiceInServicesSection: PERMISSIONS.DELETE_SERVICE_IN_SERVICES_SECTION,
  ReviewServiceInServicesSection: PERMISSIONS.REVIEW_SERVICE_IN_SERVICES_SECTION,
  EditServiceInServicesSection: PERMISSIONS.EDIT_SERVICE_IN_SERVICES_SECTION,
  showServicesSection: PERMISSIONS.SHOW_SERVICES_SECTION,
  userUpdateRequestsSectionReview: PERMISSIONS.USER_UPDATE_REQUESTS_SECTION_REVIEW,
  AddingContentInAboutSection: PERMISSIONS.ADDING_CONTENT_IN_ABOUT_SECTION,
  EditingContentInAboutSection: PERMISSIONS.EDITING_CONTENT_IN_ABOUT_SECTION,
  DeleteContentInAboutSection: PERMISSIONS.DELETE_CONTENT_IN_ABOUT_SECTION,
  RestoreContentInAboutSection: PERMISSIONS.RESTORE_CONTENT_IN_ABOUT_SECTION,
  ReviewContentInAboutSection: PERMISSIONS.REVIEW_CONTENT_IN_ABOUT_SECTION,
  ChangeToCurrentInfo: PERMISSIONS.CHANGE_TO_CURRENT_INFO,
  AddSocialMediaLinkInContactUsSection: PERMISSIONS.ADD_SOCIAL_MEDIA_LINK_IN_CONTACT_US_SECTION,
  EditSocialMediaLinkInContactUsSection: PERMISSIONS.EDIT_SOCIAL_MEDIA_LINK_IN_CONTACT_US_SECTION,
  DeleteSocialMediaLinkInContactUsSection: PERMISSIONS.DELETE_SOCIAL_MEDIA_LINK_IN_CONTACT_US_SECTION,
  AddBranchInContactUsSection: PERMISSIONS.ADD_BRANCH_IN_CONTACT_US_SECTION,
  EditBranchInContactUsSection: PERMISSIONS.EDIT_BRANCH_IN_CONTACT_US_SECTION,
  DeleteBranchInContactUsSection: PERMISSIONS.DELETE_BRANCH_IN_CONTACT_US_SECTION,
  RequestRestService: PERMISSIONS.REQUEST_REST_SERVICE,
  dayoffRequestsSectionReview: PERMISSIONS.DAYOFF_REQUESTS_SECTION_REVIEW,
  showDayoffRequestsSection: PERMISSIONS.SHOW_DAYOFF_REQUESTS_SECTION,
  RequestTransferService: PERMISSIONS.REQUEST_TRANSFER_SERVICE,
  transferRequestsSectionReview: PERMISSIONS.TRANSFER_REQUESTS_SECTION_REVIEW,
  showTransferRequestsSection: PERMISSIONS.SHOW_TRANSFER_REQUESTS_SECTION,
  RequestTransferAppealService: PERMISSIONS.REQUEST_TRANSFER_APPEAL_SERVICE,
  transferAppealRequestsSectionReview: PERMISSIONS.TRANSFER_APPEAL_REQUESTS_SECTION_REVIEW,
  showTransferAppealRequestsSection: PERMISSIONS.SHOW_TRANSFER_APPEAL_REQUESTS_SECTION,
  addSecurityDirectorateManagement: PERMISSIONS.ADD_SECURITY_DIRECTORATE_MANAGEMENT,
  editSecurityDirectorateManagement: PERMISSIONS.EDIT_SECURITY_DIRECTORATE_MANAGEMENT,
  deleteSecurityDirectorateManagement: PERMISSIONS.DELETE_SECURITY_DIRECTORATE_MANAGEMENT,
  showSecurityDirectorateManagementSection: PERMISSIONS.SHOW_SECURITY_DIRECTORATE_MANAGEMENT_SECTION,
  RequestWeaponLicenseService: PERMISSIONS.REQUEST_WEAPON_LICENSE_SERVICE,
  weaponLicenseRequestsSectionReview: PERMISSIONS.WEAPON_LICENSE_REQUESTS_SECTION_REVIEW,
  showWeaponLicenseRequestsSection: PERMISSIONS.SHOW_WEAPON_LICENSE_REQUESTS_SECTION,
  RequestExternalCorrespondenceService: PERMISSIONS.REQUEST_EXTERNAL_CORRESPONDENCE_SERVICE,
  externalCorrespondenceRequestsSectionReview: PERMISSIONS.EXTERNAL_CORRESPONDENCE_REQUESTS_SECTION_REVIEW,
  showExternalCorrespondenceRequestsSection: PERMISSIONS.SHOW_EXTERNAL_CORRESPONDENCE_REQUESTS_SECTION,
  RequestBankSalaryCardService: PERMISSIONS.REQUEST_BANK_SALARY_CARD_SERVICE,
  bankSalaryCardRequestsSectionReview: PERMISSIONS.BANK_SALARY_CARD_REQUESTS_SECTION_REVIEW,
  showBankSalaryCardRequestsSection: PERMISSIONS.SHOW_BANK_SALARY_CARD_REQUESTS_SECTION,
  RequestCareerProgressionService: PERMISSIONS.REQUEST_CAREER_PROGRESSION_SERVICE,
  careerProgressionRequestsSectionReview: PERMISSIONS.CAREER_PROGRESSION_REQUESTS_SECTION_REVIEW,
  showCareerProgressionRequestsSection: PERMISSIONS.SHOW_CAREER_PROGRESSION_REQUESTS_SECTION,
  RequestIncomeCertificateService: PERMISSIONS.REQUEST_INCOME_CERTIFICATE_SERVICE,
  incomeCertificateRequestsSectionReview: PERMISSIONS.INCOME_CERTIFICATE_REQUESTS_SECTION_REVIEW,
  showIncomeCertificateRequestsSection: PERMISSIONS.SHOW_INCOME_CERTIFICATE_REQUESTS_SECTION,
  addGrievanceTypeManagement: PERMISSIONS.ADD_GRIEVANCE_TYPE_MANAGEMENT,
  editGrievanceTypeManagement: PERMISSIONS.EDIT_GRIEVANCE_TYPE_MANAGEMENT,
  deleteGrievanceTypeManagement: PERMISSIONS.DELETE_GRIEVANCE_TYPE_MANAGEMENT,
  showGrievanceTypeManagementSection: PERMISSIONS.SHOW_GRIEVANCE_TYPE_MANAGEMENT_SECTION,
  RequestSalaryBreakdownService: PERMISSIONS.REQUEST_SALARY_BREAKDOWN_SERVICE,
  salaryBreakdownRequestsSectionReview: PERMISSIONS.SALARY_BREAKDOWN_REQUESTS_SECTION_REVIEW,
  showSalaryBreakdownRequestsSection: PERMISSIONS.SHOW_SALARY_BREAKDOWN_REQUESTS_SECTION,
  RequestGrievanceService: PERMISSIONS.REQUEST_GRIEVANCE_SERVICE,
  grievanceRequestsSectionReview: PERMISSIONS.GRIEVANCE_REQUESTS_SECTION_REVIEW,
  showGrievanceRequestsSection: PERMISSIONS.SHOW_GRIEVANCE_REQUESTS_SECTION,
  RequestDataAmendmentService: PERMISSIONS.REQUEST_DATA_AMENDMENT_SERVICE,
  showUserUpdateRequestsSection: PERMISSIONS.SHOW_USER_UPDATE_REQUESTS_SECTION,
  RequestLeaveService: PERMISSIONS.REQUEST_LEAVE_SERVICE,
  vacationRequestsSectionReview: PERMISSIONS.VACATION_REQUESTS_SECTION_REVIEW,
  showVacationRequestsSection: PERMISSIONS.SHOW_VACATION_REQUESTS_SECTION,
  editProsecutionManagement: PERMISSIONS.EDIT_PROSECUTION_MANAGEMENT,
  addProsecutionManagement: PERMISSIONS.ADD_PROSECUTION_MANAGEMENT,
  showProsecutionServicesSection: PERMISSIONS.SHOW_PROSECUTION_SERVICES_SECTION,
  RequestPublicProsecutionTransferService: PERMISSIONS.REQUEST_PUBLIC_PROSECUTION_TRANSFER_SERVICE,
  prosecutionTransferServicesSectionReview: PERMISSIONS.PROSECUTION_TRANSFER_SERVICES_SECTION_REVIEW,
  showProsecutionTransferServicesSection: PERMISSIONS.SHOW_PROSECUTION_TRANSFER_SERVICES_SECTION,
  RequestPublicProsecutionTransportationBookService: PERMISSIONS.REQUEST_PUBLIC_PROSECUTION_TRANSPORTATION_BOOK_SERVICE,
  prosecutionTransportationBookServicesSectionReview: PERMISSIONS.PROSECUTION_TRANSPORTATION_BOOK_SERVICES_SECTION_REVIEW,
  showProsecutionTransportationBookServicesSection: PERMISSIONS.SHOW_PROSECUTION_TRANSPORTATION_BOOK_SERVICES_SECTION,
  RequestComplaintsService: PERMISSIONS.REQUEST_COMPLAINTS_SERVICE,
  showComplaintRequestsSection: PERMISSIONS.SHOW_COMPLAINT_REQUESTS_SECTION,
  complaintRequestsSectionReview: PERMISSIONS.COMPLAINT_REQUESTS_SECTION_REVIEW,
  RequestCertificateService: PERMISSIONS.REQUEST_CERTIFICATE_SERVICE,
  showCertificationRequestsSection: PERMISSIONS.SHOW_CERTIFICATION_REQUESTS_SECTION,
  certificationRequestsSectionReview: PERMISSIONS.CERTIFICATION_REQUESTS_SECTION_REVIEW,
  AddingContentInTrainingSection: PERMISSIONS.ADDING_CONTENT_IN_TRAINING_SECTION,
  EditingContentInTrainingSection: PERMISSIONS.EDITING_CONTENT_IN_TRAINING_SECTION,
  DeleteContentInTrainingSection: PERMISSIONS.DELETE_CONTENT_IN_TRAINING_SECTION,
  ReviewContentInTrainingSection: PERMISSIONS.REVIEW_CONTENT_IN_TRAINING_SECTION,
  RegisterForTrainingSection: PERMISSIONS.REGISTER_FOR_TRAINING_SECTION,
  ReviewRegistrationInTrainingSection: PERMISSIONS.REVIEW_REGISTRATION_IN_TRAINING_SECTION,
  ShowTrainingSectionManagement: PERMISSIONS.SHOW_TRAINING_SECTION_MANAGEMENT,
  AddingContentInTrainingSectionManagement: PERMISSIONS.ADDING_CONTENT_IN_TRAINING_SECTION_MANAGEMENT,
  EditingContentInTrainingSectionManagement: PERMISSIONS.EDITING_CONTENT_IN_TRAINING_SECTION_MANAGEMENT,
  DeleteContentInTrainingSectionManagement: PERMISSIONS.DELETE_CONTENT_IN_TRAINING_SECTION_MANAGEMENT,
  ReviewContentInTrainingSectionManagement: PERMISSIONS.REVIEW_CONTENT_IN_TRAINING_SECTION_MANAGEMENT,
  AddingContentInTrainersSection: PERMISSIONS.ADDING_CONTENT_IN_TRAINERS_SECTION,
  EditingContentInTrainersSection: PERMISSIONS.EDITING_CONTENT_IN_TRAINERS_SECTION,
  DeleteContentInTrainersSection: PERMISSIONS.DELETE_CONTENT_IN_TRAINERS_SECTION,
  showTrainersSection: PERMISSIONS.SHOW_TRAINERS_SECTION,
  ReviewEmailInEmailSubscriptionSection: PERMISSIONS.REVIEW_EMAIL_IN_EMAIL_SUBSCRIPTION_SECTION,
  showEmailSubscriptionSection: PERMISSIONS.SHOW_EMAIL_SUBSCRIPTION_SECTION,
  showUserManagementSection: PERMISSIONS.SHOW_USER_MANAGEMENT_SECTION,
  editUserManagementSection: PERMISSIONS.EDIT_USER_MANAGEMENT_SECTION,
  addUserManagementSection: PERMISSIONS.ADD_USER_MANAGEMENT_SECTION,
  addGovernorateManagement: PERMISSIONS.ADD_GOVERNORATE_MANAGEMENT,
  editGovernorateManagement: PERMISSIONS.EDIT_GOVERNORATE_MANAGEMENT,
  showGovernorateManagementSection: PERMISSIONS.SHOW_GOVERNORATE_MANAGEMENT_SECTION,
  addMinistryManagement: PERMISSIONS.ADD_MINISTRY_MANAGEMENT,
  editMinistryManagement: PERMISSIONS.EDIT_MINISTRY_MANAGEMENT,
  showMinistryManagementSection: PERMISSIONS.SHOW_MINISTRY_MANAGEMENT_SECTION,
  addPoliceDepartmentManagement: PERMISSIONS.ADD_POLICE_DEPARTMENT_MANAGEMENT,
  editPoliceDepartmentManagement: PERMISSIONS.EDIT_POLICE_DEPARTMENT_MANAGEMENT,
  showPoliceDepartmentManagementSection: PERMISSIONS.SHOW_POLICE_DEPARTMENT_MANAGEMENT_SECTION,
  addPositionManagement: PERMISSIONS.ADD_POSITION_MANAGEMENT,
  editPositionManagement: PERMISSIONS.EDIT_POSITION_MANAGEMENT,
  showPositionManagementSection: PERMISSIONS.SHOW_POSITION_MANAGEMENT_SECTION,
  editLeaveTypeManagement: PERMISSIONS.EDIT_LEAVE_TYPE_MANAGEMENT,
  showLeaveTypeManagementSection: PERMISSIONS.SHOW_LEAVE_TYPE_MANAGEMENT_SECTION,
  AddingContentInJobAnnouncementSection: PERMISSIONS.ADDING_CONTENT_IN_JOB_ANNOUNCEMENT_SECTION,
  EditingContentInJobAnnouncementSection: PERMISSIONS.EDITING_CONTENT_IN_JOB_ANNOUNCEMENT_SECTION,
  DeleteContentInJobAnnouncementSection: PERMISSIONS.DELETE_CONTENT_IN_JOB_ANNOUNCEMENT_SECTION,
  showJobAnnouncementSection: PERMISSIONS.SHOW_JOB_ANNOUNCEMENT_SECTION,
  AddingContentInNewsImageSection: PERMISSIONS.ADDING_CONTENT_IN_NEWS_IMAGE_SECTION,
  DeleteContentInNewsImageSection: PERMISSIONS.DELETE_CONTENT_IN_NEWS_IMAGE_SECTION,
  AddingContentInSecretaryGeneralSection: PERMISSIONS.ADDING_CONTENT_IN_SECRETARY_GENERAL_SECTION,
  EditingContentInSecretaryGeneralSection: PERMISSIONS.EDITING_CONTENT_IN_SECRETARY_GENERAL_SECTION,
  DeleteContentInSecretaryGeneralSection: PERMISSIONS.DELETE_CONTENT_IN_SECRETARY_GENERAL_SECTION,
  ReviewContentInSecretaryGeneralSection: PERMISSIONS.REVIEW_CONTENT_IN_SECRETARY_GENERAL_SECTION,
  showSecretaryGeneralSection: PERMISSIONS.SHOW_SECRETARY_GENERAL_SECTION,
  AdminSystem: PERMISSIONS.ADMIN_SYSTEM,
  PermissionsSystem: PERMISSIONS.PERMISSIONS_SYSTEM,
  NoSubjectReview: PERMISSIONS.NO_SUBJECT_REVIEW,
  ViewReport: PERMISSIONS.VIEW_REPORT,
  hiringSectionManagment: PERMISSIONS.HIRING_SECTION_MANAGMENT,
  hiringSectionReview: PERMISSIONS.HIRING_SECTION_REVIEW,
  viewHiringStaticsSection: PERMISSIONS.VIEW_HIRING_STATICS_SECTION,
  schedulingDeliveringDocumentsSectionManagment: PERMISSIONS.SCHEDULING_DELIVERING_DOCUMENTS_SECTION_MANAGMENT,
  scheduleInterviewsSectionManagment: PERMISSIONS.SCHEDULE_INTERVIEWS_SECTION_MANAGMENT,
  absenteesSectionManagment: PERMISSIONS.ABSENTEES_SECTION_MANAGMENT,
  exceptionSectionManagement: PERMISSIONS.EXCEPTION_SECTION_MANAGEMENT,
  applicantReviewSectionManagement: PERMISSIONS.APPLICANT_REVIEW_SECTION_MANAGEMENT,
  roleManagementSectionManagment: PERMISSIONS.ROLE_MANAGEMENT_SECTION_MANAGMENT,
  permissionManagementSection: PERMISSIONS.PERMISSION_MANAGEMENT_SECTION,
  userAuthManagementSection: PERMISSIONS.USER_AUTH_MANAGEMENT_SECTION,
  RequestHealthCareCardService: PERMISSIONS.REQUEST_HEALTH_CARE_CARD_SERVICE,
  healthCareCardRequestsSectionReview: PERMISSIONS.HEALTH_CARE_CARD_REQUESTS_SECTION_REVIEW,
  showHealthCareCardRequestsSection: PERMISSIONS.SHOW_HEALTH_CARE_CARD_REQUESTS_SECTION,
  DeleteOwnAccount: PERMISSIONS.DELETE_OWN_ACCOUNT,
};

/**
 * Gets the permission name from a bit index
 */
export function getPermissionName(bitIndex: number): string | null {
  return BIT_INDEX_TO_NAME[bitIndex] ?? null;
}

/**
 * Gets the bit index from a permission name
 */
export function getBitIndex(permissionName: string): number {
  const index = NAME_TO_BIT_INDEX[permissionName];
  if (index === undefined) {
    throw new Error(`Permission '${permissionName}' not found`);
  }
  return index;
}

/**
 * Gets the permission BigInt value from a permission name
 */
export function getPermissionByName(permissionName: string): bigint {
  const permission = NAME_TO_PERMISSION[permissionName];
  if (permission === undefined) {
    throw new Error(`Permission '${permissionName}' not found`);
  }
  return permission;
}

/**
 * Tries to get the permission BigInt value from a permission name
 */
export function tryGetPermissionByName(permissionName: string): bigint | null {
  return NAME_TO_PERMISSION[permissionName] ?? null;
}

/**
 * Gets all available permission names
 */
export function getAllPermissionNames(): string[] {
  return Object.keys(NAME_TO_PERMISSION);
}

/**
 * Combines multiple permissions into a single bitmask
 */
export function combinePermissions(...permissions: bigint[]): bigint {
  let result = 0n;
  for (const permission of permissions) {
    result |= permission;
  }
  return result;
}

/**
 * Gets a bitmask with ALL permissions enabled
 */
export function getAllPermissions(): bigint {
  return combinePermissions(...Object.values(NAME_TO_PERMISSION));
}

